export const STORE_EVENTS = {
    created: "store_created",
    updated: "store_updated",
    deleted: "store_deleted",
    init: "store_init",
    sync: "store_sync",
};
//# sourceMappingURL=store.js.map